
// Cookie and Popup Element
let cookieBannerEl = null;
let popupEl = null;

// INERT HELPERS

function applyInert(el) {
    if (el) el.inert = true;
}

function removeInert(el) {
    if (el) el.inert = false;
}


// VISIBILITY CHECK
function isPopupVisible() {
    let el = document.querySelector('[role="dialog"][aria-modal="true"][aria-label="POPUP Form"].needsclick[class*="kl-private-reset-css-"]')
    if (!el) return false;

    // if (!document.contains(el)) return false;

    try {
        const style = getComputedStyle(el);

        return (
            style.display !== 'none'
        );
    } catch (e) {
        return false;
    }
}

function isCookieBannerVisible() {
    const host = document.querySelector('csm-cookie-consent');
    if (!host || !host.shadowRoot) return false;

    const wrapper = host.shadowRoot.querySelector('#csm-wrapper');
    return !!wrapper?.querySelector("[role='dialog'].cc-banner");
}

// Get Current Active Layer
function getActiveLayer() {
    try {
        if (isCookieBannerVisible()) return 'COOKIE';
        if (isPopupVisible()) return 'POPUP';
        return 'SITE';
    } catch (e) {
        return 'SITE';
    }
}

function isValidElement(el) {
    return el && document.contains(el);
}

// Update Interaction Based on Active Layer
function updateInteractionState() {

    if (!isValidElement(popupEl)) popupEl = null;
    if (!isValidElement(cookieBannerEl)) cookieBannerEl = null;
    const active = getActiveLayer();
    let siteContainer = document.getElementById("site-container")
    if (active === 'POPUP') {
        removeInert(popupEl);
        applyInert(cookieBannerEl);
        applyInert(siteContainer);
    }

    else if (active === 'COOKIE') {
        removeInert(cookieBannerEl);
        applyInert(popupEl);
        applyInert(siteContainer);
    }

    else {
        removeInert(cookieBannerEl);
        removeInert(popupEl);
        removeInert(siteContainer);
    }
}

// Cookie Handling 
function handleCookieHost(hostEl) {

    const shadow = hostEl.shadowRoot;
    // Remove Popover Attribure
    // hostEl?.removeAttribute("popover")
    if (!shadow) return;

    // wait for wrapper inside shadow
    const observer = new MutationObserver(() => {
        document.querySelector("csm-cookie-consent")?.removeAttribute("popover")
        const wrapper = shadow.querySelector('#csm-wrapper');
        // if (wrapper) {
        const banner = wrapper?.querySelector("[role='dialog'].cc-banner");

        // if (banner) {
        cookieBannerEl = banner;
        updateInteractionState();
        // }
        // }
    });
    updateInteractionState();
    observer.observe(shadow, { childList: true, subtree: true });
}

// observe Element
function observeForElement({
    targetSelector,
    parentEl = document.body,
    subtree = false,
    timeout = 10000,
    onFound = () => { },
    onError = () => { }
} = {}) {
    let observer = null;
    let timer = null;

    function cleanup() {
        if (observer) observer.disconnect();
        if (timer) clearTimeout(timer);
    }

    try {
        const existing = parentEl.querySelector(targetSelector);
        if (existing) {
            onFound(existing);
            return cleanup;
        }


        observer = new MutationObserver((mutations) => {
            try {
                for (const m of mutations) {
                    for (const node of m.addedNodes) {
                        if (node.nodeType !== 1) continue;

                        if (node.matches?.(targetSelector)) {
                            cleanup();
                            onFound(node);
                            return;
                        }

                        if (subtree && node.querySelector) {
                            const el = node.querySelector(targetSelector);
                            if (el) {
                                onFound(el);
                                cleanup();
                                return;
                            }
                        }
                    }
                }
            } catch (err) {
                cleanup();
                onError(err);
            }
        });

        observer.observe(parentEl, { childList: true, subtree });


        timer = setTimeout(() => {
            cleanup();
            onError(new Error(`Timeout: ${targetSelector} not found`));
        }, timeout);

    } catch (err) {
        cleanup();
        onError(err);
    }

    return cleanup;
}

// DETECT COOKIE HOST
observeForElement({
    targetSelector: 'csm-cookie-consent',
    parentEl: document.body,
    subtree: false,
    timeout: 30000,
    onFound: (el) => {

        let cookie = document.querySelector("csm-cookie-consent")
        if (cookie) {
            cookie.removeAttribute("popover")
            cookie.style.setProperty("z-index", "2147483647", "important");
        }
        handleCookieHost(el);

    },
    onError: (err) => {
        console.log("error on cookie consent", err)
    }
});

// DETECT POPUP
observeForElement({
    targetSelector: '[role="dialog"][aria-modal="true"][aria-label="POPUP Form"].needsclick[class*="kl-private-reset-css-"]',
    parentEl: document.body,
    subtree: true,
    timeout: 30000,
    onFound: (el) => {
        popupEl = el;

        // // observe visibility changes
        const observer = new MutationObserver(() => {
            updateInteractionState();
        });

        observer.observe(el, {
            attributes: true,
            attributeFilter: ['style', 'class', 'aria-hidden'],
            subtree: true
        });

        updateInteractionState();
    },
    onError: (err) => {
        console.log("error on popup", err)
    }
});

updateInteractionState();


// FallBack Case 
setTimeout(() => {
    let popupForm = document.querySelector('[role="dialog"][aria-modal="true"][aria-label="POPUP Form"].needsclick[class*="kl-private-reset-css-"]')
    popupForm?.addEventListener("click", () => {
        let siteContainer = document.getElementById("site-container")
        if (siteContainer) {
            removeInert(siteContainer)
        }
    }, { once: true })
}, 18000)

// Search  Dropdown Focus Trap 

setTimeout(() => {
    (() => {
        const selector = '#boost-sd__search-widget-init-input-0';
        let lastState = null;

        setInterval(() => {
            const el = document.querySelector(selector);
            if (!el) return;

            const state = el.getAttribute('aria-expanded');

            if (state === 'false' && lastState !== 'false') {
                el.setAttribute('aria-expanded', 'true');
            }

            lastState = state;
        }, 100);
    })();

    const searchInput = document.getElementById('boost-sd__search-widget-init-input-0');
    const closeButton = document.querySelector('.search-bar-close-icon[tabindex="0"]');
    const wrapper = document.getElementById('boost-sd__search-widget-init-wrapper');

    function getFocusableListItems() {
        return wrapper?.querySelectorAll(
            'a.boost-sd__suggestion-queries-item-link, a.boost-sd__view-all-link'
        ) || [];
    }

document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;

    const active = document.activeElement;

    const searchInput = document.getElementById('boost-sd__search-widget-init-input-0');
    const closeButton = document.querySelector('.search-bar-close-icon[tabindex="0"]');
    const wrapper = document.getElementById('boost-sd__search-widget-init-wrapper');

    const listItems = wrapper?.querySelectorAll(
        'a.boost-sd__suggestion-queries-item-link, a.boost-sd__view-all-link'
    ) || [];

    const firstItem = listItems[0];

    const dropdownOpen =
        wrapper &&
        window.getComputedStyle(wrapper).display !== 'none' &&
        listItems.length > 0;

    // IMPORTANT: if dropdown not ready, DO NOTHING
    if (!dropdownOpen) return;

    // -------------------------------
    // 1. View All → Input
    // -------------------------------
    if (active?.matches('.boost-sd__view-all-link')) {
        if (!searchInput) return;

        event.preventDefault();
        searchInput.focus();
        return;
    }

    // -------------------------------
    // 2. Input → Close
    // -------------------------------
    if (active === searchInput) {
        if (!closeButton) return;

        event.preventDefault();
        closeButton.focus();
        return;
    }
    if (active === closeButton) {
        if (!firstItem) return;

        event.preventDefault();
        firstItem.focus();
        return;
    }
});

    const target = document.querySelector(".search-menu-item-dropdown");

    if (!target) {
        console.log("Element not found");
        return;
    }

    const checkState = () => {
        const display = window.getComputedStyle(target).display;

        if (display === 'none') {
            document.removeEventListener('keydown', handleListTrap);
        } else {
            document.addEventListener('keydown', handleListTrap);
        }
    };

    function handleListTrap(e) {
        if (e.key !== 'Tab') return;

        const listItems = getFocusableListItems();
        if (!listItems.length) return;

        const first = listItems[0];
        const last = listItems[listItems.length - 1];

        const active = document.activeElement;

        if (!wrapper?.contains(active)) return;

        if (!e.shiftKey && active === last) {
            e.preventDefault();
            searchInput?.focus();
        }

        if (e.shiftKey && active === first) {
            e.preventDefault();
            searchInput?.focus();
        }
    }

    checkState();

    const observer = new MutationObserver(() => {
        checkState();
    });

    observer.observe(target, {
        attributes: true,
        attributeFilter: ["style"]
    });

}, 8000);